import { constants } from '../utils'
import base from './base'

const { headers, url, request } = base

const getSubscriptionHistory = async cpf => {
  return request(url(constants.api.subscriptionHistory.get(cpf)), {
    method: 'GET',
    headers: headers(),
  })
}

const getPdf = async id =>
  request(url(constants.api.subscriptionHistory.pdf(id)), {
    method: 'GET',
    headers: headers(true, { 'Content-Type': 'multipart/form-data', Accept: 'Application/pdf' }),
  })

const subscriptionHistoryApi = {
  getSubscriptionHistory,
  getPdf,
}

export default subscriptionHistoryApi